<template>
    <div class="my-[12px] font-sans font-normal">
        <help-panel-main-content-item
            v-for="item in items"
            :key="item.id"
            :item="item"
            :items="items" />
    </div>
</template>

<script>
    import HelpPanelMainContentItem from './HelpPanelMainContentItem.vue';

    import allStores from '../../../stores/all';

    export default {
        mixins: [allStores],

        components: {
            HelpPanelMainContentItem,
        },

        data() {
            return {
                items: [],
            };
        },

        mounted() {
            this.items = this.customizerStore.getHelpSection('DesignHelp');
        },
    };
</script>

<style scoped>
    .arrow-drop-down-icon {
        transition: transform 0.3s ease;
    }

    .arrow-drop-down-icon.rotate {
        transform: rotate(-180deg);
    }
</style>
